import { useContext, useState } from 'react';
import { Button, Dialog, DialogBody, NonIdealState, Tooltip } from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import proyectosService from '../../services/proyectos.service';
import { AppContext } from '../../utils/context/app.context';
import { toast, ToastContainer } from 'react-toastify';
import { AuthContext } from '../../utils/context/auth.context.ts';
import ProyectoEntregables from './emtregables.component.js';
import facturasService from '../../services/facturas.service.js';
import Vars from "../../utils/json/variables.json"
import FormComponent from '../../utils/components/form.component.js';
import proveedoresService from '../../services/proveedores.service.js';

export default function ProyectoEdit(props) {
    const { id, onUpdate } = props;
    const { t } = useTranslation();
    const appContext = useContext(AppContext)
    const authContext = useContext(AuthContext)

    const [modal, setModal] = useState(false)
    const [item, setItem] = useState(null)
    const [itemf, setItemf] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [canEditDocs, setEdiDocs] = useState(false)
    const [canSeeDocs, setSeeDocs] = useState(false)
    const [isADM] = useState(authContext.isSAD() || authContext.isADM())

    async function get(i) {
        if (authContext.verify({ pathname: "/pro" }, "GET")) {
            setLoading(true);
            await proyectosService.get(i.id)
                .then(res => {
                    setItem(res.data);
                    setItemf(res.data.factura[0] || null);
                    setSeeDocs(isADM || res.data.director || res.data.asignado)
                    setEdiDocs(res.data.asignado || isADM)
                    setModal(true);
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    setLoading(false);

                })
        } else {
            toast.warning(t('auth.nopermit'))
        }
    }

    function manage_proyecto(form, id_proyecto, id_factura) {
        if (authContext.verify({ pathname: "/pro" }, "PUT")) {
            toast.info(t('actions.procesing'), { autoClose: 1500, theme: "light", })
            setLoading(true);
            proyectosService.update(form, id_proyecto)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.edited'));
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    get(item);
                    setLoading(false);
                    onUpdate()
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }

        if (authContext.verify({ pathname: "/pro" }, "PUT")) {
            const form_factura = {
                descripcion: form.fac_descripcion,
                fecha: form.fac_fecha,
                estado: form.fac_estado,
                id_proyecto: id_proyecto,
            };
            if (id_factura) {
                facturasService.update(form_factura, id_factura)
                    .catch(error => appContext.errorHandler(error, toast, t))
                    .finally(() => { })
            }
            else {
                facturasService.create(form_factura)
                    .catch(error => appContext.errorHandler(error, toast, t))
                    .finally(() => { })
            }
        }

    }

    async function remove_proovedor(id, form) {
        if (authContext.verify({ pathname: "/pro" }, "DELETE")) {
            toast.info(t('actions.procesing'), { autoClose: 1500, theme: "light", });
            setLoading(true);
            return proveedoresService.delete(id)
                .then(res => {
                    if (res.data) {
                        toast.dismiss();
                        toast.success(t('actions.deleted'));
                        get(item);
                    }
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => setLoading(false))
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    async function getPairWorkers(search) {
        if (authContext.verify({ pathname: "/pro" }, "GET")) {
            return proyectosService.getWorkers(search)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    appContext.errorHandler(error, toast, t);
                    return []
                })
        } else {
            toast.warning(t('auth.nopermit'));
            return []
        }

    }

    const codRegex = /^\d\d\d\.\d\d\d\d$/i;

    const LOADING = <div class="text-center mt-5 pt-5">
        <div class="spinner-border" role="status">
        </div>
    </div>

    const NO_DATA = <div className='p-5'>
        <NonIdealState
            icon={'help'}
            iconSize={44}
            title={t('table.nodata')}
            description={t('table.nodatast')}
            layout={'vertical'}
        />
    </div>

    const FORM = (i, f) => [
        {
            title: t('pro.form.section_1'),
            inputs: [
                [
                    { id: "codigo", required: true, defaultValue: i?.codigo, title: t('pro.form.codigo'), placeholder: t('pro.form.codigo'), icon: "tag", pattern: codRegex, validateText: t('pro.form.codigo_validate') },
                    { id: "nombre", required: true, defaultValue: i?.nombre, title: t('pro.form.nombre'), placeholder: t('pro.form.nombre'), icon: "tag", },
                    { id: "municipio", defaultValue: i?.municipio, title: t('pro.form.municipio'), placeholder: t('pro.form.municipio'), icon: "map-marker", type: "list", list: appContext.getCityList() },
                    { id: "direccion", defaultValue: i?.direccion, title: t('pro.form.direccion'), placeholder: t('pro.form.direccion'), icon: "home", },
                    { id: "propietario", defaultValue: i?.propietario, title: t('pro.form.propietario'), placeholder: t('pro.form.propietario'), icon: "person" },
                    { id: "curaduria", defaultValue: i?.curaduria, title: t('pro.form.curaduria'), placeholder: t('pro.form.curaduria'), icon: "tag" },
                ],
                [
                    { id: "fecha_inicio", defaultValue: i?.fecha_inicio, title: t('pro.form.fecha_inicio'), placeholder: t('pro.form.fecha_inicio'), type: "date" },
                    { id: "fecha_entrega", defaultValue: i?.fecha_entrega, title: t('pro.form.fecha_entrega'), placeholder: t('pro.form.fecha_entrega'), type: "date" },
                    { id: "estado", defaultValue: i?.estado, title: t('pro.form.estado'), placeholder: t('pro.form.estado'), icon: "folder-open", hide: !i, type: "select", list: Vars.pro_states.map(i => ({ value: i, text: t('general.pro_states.' + i) })) },
                ],
                [
                    { id: "observaciones", defaultValue: i?.observaciones, title: t('pro.form.observaciones'), placeholder: t('pro.form.observaciones'), type: "textarea" },
                ],
            ]
        },
        {
            title: t('facturas.form.section'),
            hide: !authContext.verify({ pathname: "/pro" }, "PUT"),
            inputs: [
                [
                    { id: "fac_descripcion", defaultValue: f?.descripcion, title: t('facturas.form.descripcion'), placeholder: t('facturas.form.descripcion'), icon: "tag" },
                    { id: "fac_fecha", defaultValue: f?.fecha, title: t('facturas.form.fecha'), placeholder: t('facturas.form.fecha'), type: "date" },
                    { id: "fac_estado", defaultValue: f?.estado, title: t('facturas.form.estado'), placeholder: t('facturas.form.estado'), icon: "dollar", type: 'select', list: Vars.facturas_estado.map(i => ({ value: i, text: t(`general.facturas_estado.${i}`) })) },

                ]
            ]
        },
        {
            title: t('proveedores.form.section'),
            hide: !authContext.verify({ pathname: "/pro" }, "PUT"),
            multiple: true,
            defaultValues: i?.proveedores,
            name: 'proveedores',
            deleteApi: remove_proovedor,
            deleteAllow: authContext.verify({ pathname: "/pro" }, "DELETE"),
            inputs: [
                [
                    { id: "tipo", index: 'tipo', title: t('proveedores.form.tipo'), placeholder: t('proveedores.form.tipo'), icon: "tag", type: 'select', list: Vars.proveedor_type.map(i => ({ value: i, text: t(`general.proveedor_type.${i}`) })) },
                    { id: "id_tercero", index: 'id_tercero', text: 'persona', title: t('proveedores.form.tercero'), placeholder: t('proveedores.form.tercero'), icon: "person", type: 'list', api: getPairWorkers },
                ],
            ]
        },
    ]

    const EDIT = (i, f) => <>
        <hr />
        <h3>{t("proyecto.pro")}</h3>
        <FormComponent
            actions={{
                primary: authContext.verify({ pathname: "/pro" }, "PUT") ? { icon: i ? "edit" : "add", text: i ? t('actions.edit') : t('actions.new'), intent: "warning" } : null,
                secondary: null
            }}
            onSecondary={null}
            onSubmit={(data) => manage_proyecto(data, i.id, f?.id)}
            groups={FORM(i, f)}
        />
    </>

    const MODAL = (item, itemf) => <Dialog
        id={'proyecto-edit'}
        title={t('pro.form.edit').replace('%VAR%', item.codigo)}
        icon={"edit"}
        isOpen={modal} onClose={() => setModal(false)}
        className='modal-app'>
        <DialogBody useOverflowScrollContainer={true} >
            <ToastContainer theme="colored" />
            {isLoading ? LOADING : item ?
                <div>
                    {EDIT(item, itemf)}

                    {canSeeDocs ? <>
                        <hr />
                        <h3>{t("proyecto.ent")}</h3>
                        <div className='container-app'>
                            <ProyectoEntregables proyecto={{ ...item, id: item.id, codigo: item.codigo }} canEdit={canEditDocs} get={get} />
                        </div>
                    </> : null}

                </div>
                : NO_DATA}

        </DialogBody>
    </Dialog>

    return (<>
        {item ? MODAL(item, itemf) : null}
        <Tooltip content={t('actions.edit')} placement="top">
            <Button icon="edit" intent='warning' onClick={() => get({ id: id })} />
        </Tooltip>
    </>
    );
}